import { render, staticRenderFns } from "./IsAdetRaporu.vue?vue&type=template&id=5572e144&"
import script from "./IsAdetRaporu.vue?vue&type=script&lang=js&"
export * from "./IsAdetRaporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports